import { hexToRgbArray } from "../../color/color"
import { IColorPalette, MaterialColors } from "../../color/material"
import { str } from "../../strings"
import { defineDirective } from "../../utils/angular"

export interface ColorPickerOptions {
    includeAccentColors?: boolean
    swatches?: string[]
    required?: boolean
}

/** @internal */
export class ColorPicker {

    static create() {
        return defineDirective(ColorPicker, "shared/components/color-picker/cp.html", {
            color: "=?",
            options: "="
        })
    }

    public color: number[]

    public options: ColorPickerOptions

    public swatches: string[][]

    public standard: ReturnType<typeof getStandardColors>

    static $inject = ["$scope"]

    constructor($scope: ng.IScope) {

        $scope.$watch("vm.options", () => this.setup(MaterialColors))

    }

    private setup(palette: IColorPalette) {
        this.setupSwatches(palette)
        this.standard = getStandardColors()
    }

    private setupSwatches(palette: IColorPalette) {
        this.swatches = getSwatches(palette, this.options)
    }

    selectColor(color: string) {
        this.color = color ? hexToRgbArray(color) : null
    }

}


export function getStandardColors() {

    return [
        {
            description: str.White,
            color: "#ffffff"
        },
    ]

}

export function getSwatches(palette: IColorPalette, options: ColorPickerOptions = {}) {

    options.swatches = options.swatches || Object.keys(palette)

    return options.swatches.map(s => {

        let swatch = palette[s]

        if (swatch) {

            let colors = Object.keys(swatch).map(key => {

                if (options.includeAccentColors || (key[0] != 'a')) {
                    return swatch[key]
                }

            }).filter(c => !!c)

            return colors

        }

    }).filter(s => !!s)

}
